import { useMemo } from "react";
import { dataFilter } from "../filters/dataFilter";
export var useDataFilter = function (data, filters, options) {
  return useMemo(function () {
    return [dataFilter(data, filters, options), Date.now()];
  }, [data, filters, options]);
};